import createReactComponent from '../createReactComponent';
export default createReactComponent('info-circle', 'IconInfoCircle', [
  ['path', { d: 'M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M12 9h.01', key: 'svg-1' }],
  ['path', { d: 'M11 12h1v4h1', key: 'svg-2' }],
]);
